<template>
  <div class="col-1-1">
    <div
      v-if="validaRegraByDimensao(dimensaoRegra)"
      :class="['regra', { 'regra-and': form.validarTodasRegras }]"
    >
      <h4 v-if="titulo">{{titulo}}</h4>

      <div class="regra-container">
        <div
          v-for="dimensao in dimensoes"
          :key="dimensao.coluna"
          class="regra-dimensao"
        >
          <label>{{ dimensao.label }}</label>
          <select
            class="form-control"
            v-model="dimensaoRegra[`dimensao${dimensao.coluna}`]"
            @change="clonarRegra(dimensaoRegra)"
            :disabled="form.erpId && form.id"
          >
            <option></option>
            <option
              v-for="itemDimensao in dimensao.dimensoes"
              :key="itemDimensao.id"
              :value="itemDimensao.id"
            >
              {{ itemDimensao.desc }}
            </option>
          </select>
        </div>
      </div>

      <div class="button-delete-container">
        <div></div>
        <button
          type="button"
          class="button button-error"
          @click="excluirRegra(index)"
          :disabled="form.erpId && form.id"
        >
          <fa-icon icon="trash-alt" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _find from "lodash/find";

export default {
  name: "RegrasSegmentos",
  props: {
    form: { type: Object, required: true },
    dimensaoRegra: { type: Object, required: true },
    dimensoes: { type: Array, required: true },
    index: { type: Number, required: true },
    titulo: { type: String, required: false }
  },
  methods: {
    validaDimensao(dimensao, coluna) {
      if (!dimensao) return true;
      const _dimensao = _find(this.dimensoes, (d) => d.coluna === coluna);
      return _dimensao
        ? _dimensao.dimensoes.some((e) => e.id === dimensao)
        : false;
    },
    validaRegraByDimensao(regra) {
      for (let i = 1; i <= 10; i++) {
        if (!this.validaDimensao(regra[`dimensao${i}`], i)) return false;
      }
      return true;
    },
    clonarRegra(regra) {
      if (regra.aplicaregra) {
        for (let i = 1; i <= 10; i++) {
          regra[`dimensaoaplicacao${i}`] = regra[`dimensao${i}`];
        }
        regra.dimensaoRegraAplicacao = regra.dimensaoRegra;
      }
    },
    excluirRegra(index) {
      this.form.dimensoes.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.regra {
  position: relative;
  border: 2px solid #ddd;
  padding: 12px;
  margin-bottom: 24px;
}

.regra + .regra::before {
  position: absolute;
  text-align: center;
  content: "Ou a regra abaixo deve ser válida";
  top: -22px;
}

.regra-and + .regra-and::before {
  content: "E a regra abaixo também deve válida";
}

.regra-container {
  display: flex;
  position: relative;
  margin-bottom: 16px;
}

.regra-dimensao {
  position: relative;
  margin-right: 16px;
}

.regra-dimensao + .regra-dimensao::before {
  position: absolute;
  bottom: 5px;
  left: -12px;
  content: "e";
}

.regra-dimensao label {
  font-size: 12px;
  font-weight: bold;
}

.button-delete-container {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button-delete-container button {
  float: right;
}
</style>
